import React from "react";

import { faCalendar } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Date } from "~/common";
import JumpToResultWrapper from "~/search/JumpTo/JumpToResult/JumpToResultWrapper";

import type { JumpToResultSearch_result$data as JumpToResultType } from "~/__generated__/JumpToResultSearch_result.graphql";

import styles from "./JumpToResult.module.css";

interface JumpToEventResultProps {
	event: Extract<JumpToResultType, { __typename: "Event" }>;
	index?: number;
}

export default function JumpToEventResult({ event, index }: JumpToEventResultProps) {
	return (
		<JumpToResultWrapper
			index={index}
			to={event.nextOccurrence?.url || event.previousOccurrence?.url || event.url}
			icon={<FontAwesomeIcon icon={faCalendar} />}
			endAlignedElement={<Date className={styles.meta} date={event.start} format="lll" />}
			title={event.title}
		/>
	);
}
